export const itemsListData = [
    { label: "Serviços", anchor: "#services" },
    { label: "Quem Somos", anchor: "#pillars" },
    { label: "Casos de Sucesso", anchor: "#successCases" },
    { label: "Clientes", anchor: "#clients" },
    { label: "Blog", to: "/blog" },
    { label: "Trabalhe conosco", to: "/carreiras" }
];